import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import LoadingOverlay from "@components/LoadingOverlay/LoadingOverlay";
import UnauthorizedRedirection from "@components/UnauthorizedRedirection/UnauthorizedRedirection";
import type { VesselCallStatusContextType } from "@features/vessel-call/vessel-call-status/VesselCallStatus";
import { paths } from "@utils/navigation";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useNavigate, useOutletContext } from "react-router-dom";

const LANG_BASE = "vessel-call.operations";

const operationTabs = [
  {
    labelKey: `${LANG_BASE}.disputes`,
    path: paths.vesselCall.operations.disputes,
    testId: "operations-tab-disputes",
  },
] as const;

const OperationsContainer = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const outletContext = useOutletContext<VesselCallStatusContextType>();
  const { canAccessOperations, isOperationsAccessLoading } = outletContext;

  const activeTab = operationTabs.findIndex((tab) => location.pathname.includes(`/${tab.path}`));
  const currentTab = activeTab === -1 ? 0 : activeTab;

  if (isOperationsAccessLoading) {
    return <LoadingOverlay loading={isOperationsAccessLoading} />;
  }

  if (!canAccessOperations) {
    return <UnauthorizedRedirection />;
  }

  return (
    <div className="w-full">
      <Tabs
        value={currentTab}
        onChange={(_, index: number) => navigate(operationTabs[index].path)}
        aria-label={t(`${LANG_BASE}.tabs-label`)}
        sx={{
          "borderBottom": "1px solid var(--stroke-secondary-stroke, #E6EDF2)",
          "minHeight": 40,
          "& .MuiTab-root": {
            textTransform: "none",
            fontSize: "1rem",
            minHeight: 40,
            minWidth: "auto",
            px: 2,
          },
        }}
      >
        {operationTabs.map((tab) => (
          <Tab key={tab.path} label={t(tab.labelKey)} data-testid={tab.testId} />
        ))}
      </Tabs>

      <div className="pt-4">
        <Outlet context={outletContext} />
      </div>
    </div>
  );
};

export default OperationsContainer;
